export default function IconDropdownCaret({
    style,
    fill="#676767",
}){
    return <svg style={style} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 8L0 0L8 7.05716e-07L4 8Z" fill={fill} />
    </svg>        
}